<template>
    <v-card :class="['pl-5', 'pr-5', 'mt-5', 'mb-5']">
        <v-row dense>
            <v-col :cols="12" :sm="6" :md="3" :lg="3" :class="['pl-2', 'pr-2', 'pt-2', 'pb-2']">
                <v-row dense>
                    <v-col :cols="6" :sm="12"><b>{{this.qualityNotification.DisplayName}}</b></v-col>
                    <v-col :cols="6" :sm="12"><i>{{$t('components.qualityNotificationComponent.createdOn', { formattedDate: this.getCreationDateTimeForQualityNotificationComponent() })}}</i></v-col>
                </v-row>
            </v-col>
            <v-divider vertical :class="['mt-2', 'mb-2', 'd-none d-sm-flex']"></v-divider>
            <v-col :cols="12" :sm="6" :md="2" :lg="2" :class="['pl-2', 'pr-2', 'pt-2', 'pb-2']">
                <v-row dense>
                    <v-col :cols="6" :sm="12"><b>{{$t('components.qualityNotificationComponent.asignee')}}</b></v-col>
                    <v-col v-if="this.qualityNotification.ResponsibleUser == null" :cols="6" :sm="12"><i>noch nicht zugewiesen</i></v-col>
                    <v-col v-else :cols="6" :sm="12">{{this.qualityNotification.ResponsibleUser.DisplayName}}</v-col>
                </v-row>
            </v-col>
            <v-divider vertical :class="['mt-2', 'mb-2', 'd-none d-md-flex']"></v-divider>
            <v-col :cols="12" :sm="4" :md="2" :lg="2" :class="['pl-2', 'pr-2', 'pt-2', 'pb-2']">
                <v-row dense>
                    <v-col :cols="6" :sm="12"><b>{{$t('components.qualityNotificationComponent.notificationStatus')}}</b></v-col>
                    <v-col :cols="6" :sm="12">
                        <v-chip v-if="this.isQualityNotificationNew()" small color="gray">{{$t('components.qualityNotificationComponent.statuses.new')}}</v-chip>
                        <v-chip v-if="this.isQualityNotificationInProcessing()" small color="orange">{{$t('components.qualityNotificationComponent.statuses.inProcessing')}}</v-chip>
                        <v-chip v-if="this.isQualityNotificationDone()" small color="green">{{$t('components.qualityNotificationComponent.statuses.done')}}</v-chip>
                        <v-chip v-if="this.isQualityNotificationNotAccepted()" small color="red">{{$t('components.qualityNotificationComponent.statuses.notAccepted')}}</v-chip>
                    </v-col>
                </v-row>
            </v-col>
            <v-fade-transition>
                <v-divider vertical :class="['mt-2', 'mb-2', showExpansion == false ? 'd-none d-sm-flex' : '']" v-show="!showExpansion"></v-divider>
            </v-fade-transition>
            <v-col :cols="12" :sm="4" :md="2" :lg="2" :class="['pl-2', 'pr-2', 'pt-2', 'pb-2', 'd-none', 'd-sm-block']">
                <v-row dense>
                    <v-col>
                        <v-fade-transition>
                            <b v-show="!showExpansion">{{$t('components.qualityNotificationComponent.delivery')}}</b>
                        </v-fade-transition>
                    </v-col>
                    <v-col v-if="this.getDeliveryFieldOrders.length > 1" :class="['d-flex', 'justify-end']">
                        <v-fade-transition>
                            <v-icon
                                v-show="!showExpansion"
                                dense
                                color="green darken-2"
                                >
                                mdi-information
                            </v-icon>
                        </v-fade-transition>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col v-if="this.getDeliveryFieldOrders.length === 0">
                        <v-fade-transition>
                            <i v-show="!showExpansion">{{$t('components.qualityNotificationComponent.deliveryNotCreatedYet')}}</i>
                        </v-fade-transition>
                    </v-col>
                    <v-col v-else>
                        <v-fade-transition>
                            <div v-show="!showExpansion">
                                <abbr :title="$t('components.qualityNotificationComponent.deliveryCalendarWeek.explanation')">{{$t('components.qualityNotificationComponent.deliveryCalendarWeek.abbreviation')}}</abbr>
                                <span>&nbsp;</span>
                                <span>{{$IsoDateTime2Luxon(this.getDeliveryFieldOrders[this.getDeliveryFieldOrders.length-1].PlannedDate).weekNumber}}</span>
                            </div>
                        </v-fade-transition>
                    </v-col>
                </v-row>
            </v-col>
            <v-fade-transition>
                <v-divider vertical :class="['mt-2', 'mb-2', showExpansion == false ? 'd-none d-sm-flex' : '' ]" v-show="!showExpansion"></v-divider>
            </v-fade-transition>
            <v-col :cols="12" :sm="4" :md="2" :lg="2" :class="['pl-2', 'pr-2', 'pt-2', 'pb-2', 'd-none', 'd-sm-block']">
                <v-row dense>
                    <v-col>
                        <v-fade-transition>
                            <b v-show="!showExpansion">{{$t('components.qualityNotificationComponent.installation')}}</b>
                        </v-fade-transition>
                    </v-col>
                    <v-col v-if="this.getInstallationFieldOrders.length > 1" :class="['d-flex', 'justify-end']">
                        <v-fade-transition>
                            <v-icon
                                v-show="!showExpansion" 
                                dense
                                color="green darken-2"
                                >
                                mdi-information
                            </v-icon>
                        </v-fade-transition>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col v-if="this.getInstallationFieldOrders.length === 0">
                        <v-fade-transition>
                            <i v-show="!showExpansion">{{$t('components.qualityNotificationComponent.installationNotCreatedYet')}}</i>
                        </v-fade-transition>
                    </v-col>
                    <v-col v-else>
                        <v-fade-transition>
                            <div v-show="!showExpansion">
                                <abbr :title="$t('components.qualityNotificationComponent.installationCalendarWeek.explanation')">{{$t('components.qualityNotificationComponent.installationCalendarWeek.abbreviation')}}</abbr>
                                <span>&nbsp;</span>
                                <span>{{$IsoDateTime2Luxon(this.getInstallationFieldOrders[this.getInstallationFieldOrders.length-1].PlannedDate).weekNumber}}</span>
                            </div>
                        </v-fade-transition>
                    </v-col>
                </v-row>
            </v-col>
            <v-col :class="['pl-2', 'pr-2', 'pt-2', 'pb-2', 'd-flex', 'justify-end']">
                <v-btn
                    icon
                    x-large
                    @click="showExpansion = !showExpansion"
                >
                    <v-icon>{{ showExpansion ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                </v-btn>
            </v-col>
        </v-row>
        <div v-show="showExpansion">
            <v-expand-transition>
                <quality-notification-position-component
                v-for="qualityNotificationPosition in qualityNotification.QualityNotificationPositions"
                :key="qualityNotificationPosition.Id"
                    :qualityNotificationPosition="qualityNotificationPosition">
                </quality-notification-position-component>
            </v-expand-transition>
        </div>
    </v-card>
</template>

<script>
import { FieldOrderTypes, QualityNotificationStatus } from '../plugins/customer-portal/types';
import QualityNotificationPositionComponent from './QualityNotificationPositionComponent.vue';
export default {
    components: { QualityNotificationPositionComponent },
    name: "QualityNotificationComponent",
    data: function() {
        return {
            showExpansion: false
        }
    },
    props: {
        qualityNotification: Object,
    },
    methods: {
        /**
         * Get the delivery of the QualityNotification.
         * @returns {(Date[]|null)} The delivery dates or null
         */
        getDeliveryForQualityNotificationComponent: function() {
            let result = null;
            if (this.qualityNotification === undefined || this.qualityNotification === null) {
                return result;
            }
            if (this.qualityNotification.QualityNotificationPositions === undefined || this.qualityNotification.QualityNotificationPositions === null || !Array.isArray(this.qualityNotification.QualityNotificationPositions) || this.qualityNotification.QualityNotificationPositions.length === 0) {
                return result;
            }
            let firstQualityNotificationPosition = this.qualityNotification.QualityNotificationPositions[0];
            if (firstQualityNotificationPosition === undefined || firstQualityNotificationPosition === null) {
                return result;
            }
            if (firstQualityNotificationPosition.QualityWorkOrder === undefined || firstQualityNotificationPosition.QualityWorkOrder === null) {
                return result;
            }
            if (firstQualityNotificationPosition.QualityWorkOrder.WorkOrderFieldOrders === undefined || firstQualityNotificationPosition.QualityWorkOrder.WorkOrderFieldOrders === null || !Array.isArray(firstQualityNotificationPosition.QualityWorkOrder.WorkOrderFieldOrders) || firstQualityNotificationPosition.QualityWorkOrder.WorkOrderFieldOrders.length === 0) {
                return result;
            }
            let workOrderFieldOrders = firstQualityNotificationPosition.QualityWorkOrder.WorkOrderFieldOrders;
            let deliveryWorkOrderFieldOrders = workOrderFieldOrders.filter((wofo) => [FieldOrderTypes.LK.Id, FieldOrderTypes.LM.Id, FieldOrderTypes.LL.Id].includes(wofo.FieldOrder.FieldOrderTypeId));
            if (deliveryWorkOrderFieldOrders.length === 0) {
                return result;
            }
            result = [];
            deliveryWorkOrderFieldOrders.forEach(deliveryWorkOrderFieldOrder => {
                if (deliveryWorkOrderFieldOrder.FieldOrder != null && deliveryWorkOrderFieldOrder.FieldOrder.Tour != null && deliveryWorkOrderFieldOrder.FieldOrder.Tour.StartDate != null) {
                    result.push(deliveryWorkOrderFieldOrder.FieldOrder.Tour.StartDate);
                } else if (deliveryWorkOrderFieldOrder.FieldOrder != null && deliveryWorkOrderFieldOrder.FieldOrder.Tour != null && deliveryWorkOrderFieldOrder.FieldOrder.Tour.CalendarWeek != null && deliveryWorkOrderFieldOrder.FieldOrder.Tour.CalendarWeek.DateFrom != null) {
                    result.push(deliveryWorkOrderFieldOrder.FieldOrder.Tour.CalendarWeek.DateFrom);
                } else {
                    return result.push(null);
                }
            });
            return result;
        },
        /**
         * Converts the creation time of the QualityNotification to a string.
         * @returns {(String|null)} The converted Date to String or null.
         */
        getCreationDateTimeForQualityNotificationComponent: function () {
            let result = null;
            if (this.qualityNotification === undefined || this.qualityNotification === null) {
                return result;
            }
            if (this.qualityNotification.Created === undefined || this.qualityNotification.Created === null) {
                return result;
            }
            result = this.$d(Date.parse(this.qualityNotification.Created), 'short');
            return result;
        },
        isQualityNotificationNew() {
            return [QualityNotificationStatus.Open].includes(this.qualityNotification.QualityNotificationFlag.QualityNotificationStatusId);
        },
        isQualityNotificationInProcessing() {
            return [QualityNotificationStatus.Inquiry, QualityNotificationStatus.Processing, QualityNotificationStatus.Clarification].includes(this.qualityNotification.QualityNotificationFlag.QualityNotificationStatusId);
        },
        isQualityNotificationDone() {
            return [QualityNotificationStatus.Rectified, QualityNotificationStatus.Completed].includes(this.qualityNotification.QualityNotificationFlag.QualityNotificationStatusId);
        },
        isQualityNotificationNotAccepted() {
            return [QualityNotificationStatus.Deleted].includes(this.qualityNotification.QualityNotificationFlag.QualityNotificationStatusId);
        },
        toggleShowExpansion() {
            this.showExpansion = !this.showExpansion;
            this.$emit('showExpansionToggled', this.showExpansion);
        }
    },
    computed: {
        getInstallationFieldOrders: {
            /**
             * @returns {(Array<FieldOrder>)} Gets an Array of FieldOrders or null if not present.
             */
            get: function() {
                let result = [];
                if (this.qualityNotification === undefined || this.qualityNotification === null) {
                    return result;
                }
                if (this.qualityNotification.QualityNotificationPositions === undefined || this.qualityNotification.QualityNotificationPositions === null || !Array.isArray(this.qualityNotification.QualityNotificationPositions) || this.qualityNotification.QualityNotificationPositions.length === 0) {
                    return result;
                }
                let firstQualityNotificationPosition = this.qualityNotification.QualityNotificationPositions[0];
                if (firstQualityNotificationPosition === undefined || firstQualityNotificationPosition === null) {
                    return result;
                }
                if (firstQualityNotificationPosition.QualityWorkOrder === undefined || firstQualityNotificationPosition.QualityWorkOrder === null) {
                    return result;
                }
                if (firstQualityNotificationPosition.QualityWorkOrder.WorkOrderFieldOrders === undefined || firstQualityNotificationPosition.QualityWorkOrder.WorkOrderFieldOrders === null || !Array.isArray(firstQualityNotificationPosition.QualityWorkOrder.WorkOrderFieldOrders) || firstQualityNotificationPosition.QualityWorkOrder.WorkOrderFieldOrders.length === 0) {
                    return result;
                }

                let workOrderFieldOrders = firstQualityNotificationPosition.QualityWorkOrder.WorkOrderFieldOrders;
                let installationWorkOrderFieldOrders = workOrderFieldOrders.filter((wofo) => [FieldOrderTypes.LM.Id, FieldOrderTypes.M.Id].includes(wofo.FieldOrder.FieldOrderTypeId));
                if (installationWorkOrderFieldOrders.length === 0) {
                    return result;
                }
                installationWorkOrderFieldOrders.forEach(installationWoFo => {
                    result.push(installationWoFo.FieldOrder);
                });
                return result;
            }
        },
        getDeliveryFieldOrders: {
            /**
             * @returns {(Array<FieldOrder>)} Gets an Array of FieldOrders or null if not present.
             */
            get: function() {
                let result = [];
                if (this.qualityNotification === undefined || this.qualityNotification === null) {
                    return result;
                }
                if (this.qualityNotification.QualityNotificationPositions === undefined || this.qualityNotification.QualityNotificationPositions === null || !Array.isArray(this.qualityNotification.QualityNotificationPositions) || this.qualityNotification.QualityNotificationPositions.length === 0) {
                    return result;
                }
                let firstQualityNotificationPosition = this.qualityNotification.QualityNotificationPositions[0];
                if (firstQualityNotificationPosition === undefined || firstQualityNotificationPosition === null) {
                    return result;
                }
                if (firstQualityNotificationPosition.QualityWorkOrder === undefined || firstQualityNotificationPosition.QualityWorkOrder === null) {
                    return result;
                }
                if (firstQualityNotificationPosition.QualityWorkOrder.WorkOrderFieldOrders === undefined || firstQualityNotificationPosition.QualityWorkOrder.WorkOrderFieldOrders === null || !Array.isArray(firstQualityNotificationPosition.QualityWorkOrder.WorkOrderFieldOrders) || firstQualityNotificationPosition.QualityWorkOrder.WorkOrderFieldOrders.length === 0) {
                    return result;
                }
                let workOrderFieldOrders = firstQualityNotificationPosition.QualityWorkOrder.WorkOrderFieldOrders;
                let deliveryWorkorderFieldOrders = workOrderFieldOrders.filter((wofo) => [FieldOrderTypes.LK.Id, FieldOrderTypes.LM.Id, FieldOrderTypes.LL.Id].includes(wofo.FieldOrder.FieldOrderTypeId));
                if (deliveryWorkorderFieldOrders.length === 0) {
                    return result;
                }
                deliveryWorkorderFieldOrders.forEach(deliveryWoFo => {
                     result.push(deliveryWoFo.FieldOrder);
                });
                return result;
            }
        },
    }
}
</script>

<style>

</style>